import { Box, Button, Flex, Text } from '@optiaxiom/react';

import InstructionsSettingsEmptyState from '@frontend/assets/InstructionsSettingsEmptyState.svg';

import { emptyPageContainer } from './EmptyPage.css';

type EmptyPageProps = {
  title: string;
  description: string;
  image?: string;
  onClickPrimaryButton?: () => void;
  primaryButtonText?: string;
};

export function EmptyPage({
  title,
  description,
  image,
  onClickPrimaryButton,
  primaryButtonText,
}: EmptyPageProps) {
  return (
    <Box h="full" w="full" flex="1">
      <Flex className={emptyPageContainer} flex="1" h="full" w="full" flexDirection="column">
        <img src={image ?? InstructionsSettingsEmptyState} alt={title} />
        <Text color="fg.tertiary" fontSize="md" textAlign="center">
          {description}
        </Text>
        {onClickPrimaryButton && (
          <Button appearance="primary" onClick={onClickPrimaryButton}>
            {primaryButtonText}
          </Button>
        )}
      </Flex>
    </Box>
  );
}
